import { FeatureCategory } from '../types';

export const dailyLivingFeatures: FeatureCategory = {
  name: "Daily Living & Independence",
  icon: "ClipboardCheck",
  features: [
    {
      name: "Is This a Scam?",
      description: "Paste a suspicious text, email, or phone call script and get an instant, plain-language verdict, with red flags explained and clear next steps. Peace of mind in seconds.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Food Delivery Finder",
      description: "Find meal delivery services in your area, from prepared meals to grocery delivery, so eating well stays easy.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Find Rides",
      description: "Find local transportation options, from rideshare to senior shuttle services, so getting around stays simple.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Daily Living Skills",
      description: "Assessment of Activities of Daily Living including bathing, dressing, eating, and mobility.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Life Skills Check",
      description: "Instrumental Activities of Daily Living assessment covering cooking, cleaning, managing finances, and transportation.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Timed Up & Go (Mobility)",
      description: "Simple mobility assessment to evaluate fall risk and movement capabilities.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Vision Test",
      description: "Basic vision screening tools to monitor eyesight changes and recommend professional care.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Driving Safety",
      description: "Assessment of driving safety and capabilities with recommendations for continued safe driving.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    }
  ]
};
